var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogoPlaceholder = function SvgLogoPlaceholder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 140 32",
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 4,
    width: 32,
    height: 6,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 10,
    width: 6,
    height: 18,
    rx: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2 22C41 22 39 20.3 39 17.6c0-2.8 2.2-4.4 6.2-4.4h3.3v-1c0-1.6-.9-2.5-2.8-2.5H44c-1.4 0-2.3.6-2.5 1.7h-4.8C37 8 39.8 6 44.2 6c4.7 0 7.6 2.4 7.6 6.3V22h-4.6v-2c-1 1.4-2.8 2.3-4.7 2.3zm1.4-3.2h2.8c1.6 0 3-1 3-2.3v-1h-3.1c-1.9 0-3 .7-3 1.9 0 .9.8 1.4 1.9 1.4zM63.5 22c-4.1 0-6.6-1.7-6.7-5h4.7c.1 1.2.9 1.9 2.5 1.9h1.7c1.4 0 2.1-.6 2.1-1.4 0-.7-.5-1.1-1.6-1.3l-3.3-.4c-3.2-.4-4.7-2-4.7-4.6 0-3.1 2.7-5 7-5s6.7 1.7 6.8 4.9h-4.7c-.1-1.1-.8-1.7-2.3-1.7h-1.6c-1.2 0-1.9.6-1.9 1.3 0 .8.5 1.2 1.6 1.4l3.4.4c3.3.4 4.7 2 4.7 4.6 0 3.3-2.8 5.1-7.6 5.1zM83.1 22c-4.1 0-6.6-1.7-6.7-5h4.7c.1 1.2.9 1.9 2.5 1.9h1.7c1.4 0 2.1-.6 2.1-1.4 0-.7-.5-1.1-1.6-1.3l-3.3-.4c-3.2-.4-4.7-2-4.7-4.6 0-3.1 2.7-5 7-5s6.7 1.7 6.8 4.9h-4.7c-.1-1.1-.8-1.7-2.3-1.7H83c-1.2 0-1.9.6-1.9 1.3 0 .8.5 1.2 1.6 1.4l3.4.4c3.3.4 4.7 2 4.7 4.6 0 3.3-2.8 5.1-7.6 5.1z"
  }))));
};
export default SvgLogoPlaceholder;